import React from 'react';
import { useTranslation } from 'react-i18next';

const DetailView = ({ item, renderIndustries, renderTypes, renderRemoteWorkStatus, classes }) => {
  const { t } = useTranslation();

  return (
    <div className={classes.detailText}>
      <div className={classes.filters}>
        {t('dashboard.settings.filters')}
        {item.JobAlertIndustries && renderIndustries(item.JobAlertIndustries)}
        {item.JobAlertIndustries.length && item.JobAlertContractTypes.length ? (
          <span> &bull;&nbsp;{renderTypes(item.JobAlertContractTypes)}</span>
        ) : (
          <span> {renderTypes(item.JobAlertContractTypes)}</span>
        )}
        {(item.JobAlertIndustries.length || item.JobAlertContractTypes.length) && item.RemoteWork ? (
          <span> &bull;&nbsp;{renderRemoteWorkStatus(item.RemoteWork)}</span>
        ) : (
          <span> {renderRemoteWorkStatus(item.RemoteWork)}</span>
        )}
      </div>
      <div>
        {t('dashboard.settings.frequency')} {item.Frequency}{' '}
      </div>
    </div>
  );
};

export default DetailView;
